import { render, staticRenderFns } from "./petDetail.vue?vue&type=template&id=121c5d6a&scoped=true&"
import script from "./petDetail.vue?vue&type=script&lang=js&"
export * from "./petDetail.vue?vue&type=script&lang=js&"
import style0 from "./petDetail.vue?vue&type=style&index=0&id=121c5d6a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121c5d6a",
  null
  
)

export default component.exports